import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import bookmarksView from './views/bookmarksView.js';
import previewView from './views/previewView.js';
import PaginationView from './views/paginationView.js';
import AddRecipeView from './views/addRecipeView.js';
import { MODAL_CLOSE_SEC } from './config';

import { async } from 'regenerator-runtime';
import 'regenerator-runtime/runtime';
import 'regenerator-runtime/runtime';
import 'core-js/stable'

// if(module.hot){
//   module.hot.accept();
// }

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

// https://forkify-api.herokuapp.com/v2

const controlRecipe = async function(){
  try{
    const id =  window.location.hash.slice(1);
    if(!id) return;
    //1.load recipe
    await model.loadRecipe(id);
    recipeView.renderSpinner();
    // rendering recipe
    const {recipe} = model.state;
    recipeView.render(recipe);
    resultsView.update(model.getSearchResultsPage());
    bookmarksView.update(model.state.bookMarks)
  }
  catch(err){
      recipeView.renderError();
  }
};

const controlSearchResults = async function(){
  try{
    resultsView.renderSpinner();
    let query = searchView.getQuery();
    if(!query) return;
    await model.loadSearchResults(query);
  }catch(err){
    console.log(err)
  }
  resultsView.render(model.getSearchResultsPage());

  //render pagination
  PaginationView.render(model.state.search);
}

const controlPagination = function(gotoPage){
  resultsView.render(model.getSearchResultsPage(gotoPage));
  PaginationView.render(model.state.search);
}

const controlServings = function(newServings){
  model.updateServings(newServings);
  recipeView.update(model.state.recipe);
}

const controAddBookmark = function(){
  if(!model.state.recipe.bookmarked){
    model.addBookMark(model.state.recipe);
  }
  else{
    model.deleteBookmark(model.state.recipe.id)
  }
  recipeView.update(model.state.recipe);
  bookmarksView.render(model.state.bookMarks);
}

const controlBookmarks = function(){
  bookmarksView.render(model.state.bookMarks);
}

const controlAddRecipe = async function(newRecipe){
  try{
    AddRecipeView.renderSpinner();
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);
    recipeView.render(model.state.recipe);
    AddRecipeView.renderMessage();
    bookmarksView.render(model.state.bookMarks);
    window.history.pushState(null, '',`#${model.state.recipe.id}`);
    setTimeout(function(){
      AddRecipeView.toggleWindow();
    },MODAL_CLOSE_SEC*1000);
    
  }catch(err){
    console.error(err);
    AddRecipeView.renderError(err.message);
  }
}
// ////"parcel-bundler": "^1.12.5"
// "@parcel/transformer-image": "^2.0.0-rc.0",
//     "@parcel/transformer-sass": "^2.0.0-rc.0",
//     "parcel": "^2.0.0-rc.0",

const init = function(){
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandlerUpdateServings(controlServings);
  searchView.addHandlerSearch( controlSearchResults );
  bookmarksView.addHandlerRender( controlBookmarks );
  PaginationView.addClickHandler(controlPagination);
  recipeView.addHandlerAddBookmark(controAddBookmark);
  AddRecipeView.addHandlerUpload(controlAddRecipe);
}
init();